var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMosaicTwowayStop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.754,
    height: 40.667,
    viewBox: "0 0 57.754 40.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3329",
    "data-name": "Group 3329",
    transform: "translate(-122.205 -12.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M151.691,34.518a2.35,2.35,0,0,1-1.663-.685v0a2.354,2.354,0,0,1,0-3.327,2.41,2.41,0,0,1,3.328,0,2.351,2.351,0,0,1-1.664,4.015m-.25-2.1a.358.358,0,0,0,.5,0,.354.354,0,0,0,0-.5.3.3,0,0,0-.5,0,.355.355,0,0,0,0,.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M179.959,38.065,165.087,22.949v8.217H154.229L172.708,13.9a1,1,0,1,0-1.365-1.461L161.08,22.026v-.02h-24V13.788L122.205,28.9l14.871,14.769V33.26l8.871-.094h3.214l-7.773,7.266h-.939v.877L132.4,48.828a1,1,0,1,0,1.365,1.46l8.406-7.856h22.911v10.4Zm-34.023-6.9h-.97v.011l-9.89.1v7.587l-10.05-9.981,10.05-10.215v5.333h23.886l-7.661,7.16Zm-1.62,9.266,7.774-7.266h15V27.833l10.05,10.216-10.05,9.979v-7.6Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaicTwowayStop);
export default __webpack_public_path__ + "static/media/MosaicTwowayStop.0ebe7a1dfbed9d473a89e5ed303a15fa.svg";
export { ForwardRef as ReactComponent };